import { createSelector } from '@ngrx/store';

import { getCurrentRoute } from '../getCurrentRoute';

export const routeIsAccountPage = (regExp: RegExp = /\/account(\/[a-zA-Z/]{1,})?$/i) =>
    createSelector(getCurrentRoute, (route) => (route === null ? null : route.url.match(regExp) !== null));
